'use strict';

module.exports.futureQuoteGrid = function () {
    return `
        <div rv-if="data.datatype | = 'future'">
            <div class="pure-g">
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-l">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-last"
                            rv-if="data.pricedata.last"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.last| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.last | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-change"
                            rv-if="data.pricedata.change"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.change| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.change | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-open"
                            rv-if="data.pricedata.open"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.open| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.open | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-high"
                            rv-if="data.pricedata.high"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.high| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.high | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-bid"
                            rv-if="data.pricedata.bid"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.bid| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.bid | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-bidsize"
                            rv-if="data.pricedata.bidsize"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.bidsize| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.bidsize | numeraljs '0'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-totalshares"
                            rv-if="data.fundamental.totalsharesoutstanding"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.totalshares| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.fundamental.totalsharesoutstanding | numeraljs '0.00a'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-week52high"
                            rv-if="data.fundamental.week52high"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.yearhigh| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-popup-link"
                                        rv-on-click="data.togglePopup"
                                        data-popuptype="week52low"
                                    >
                                        {data.fundamental.week52high.content | asQHLast tLang}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-contracthigh"
                            rv-if="data.contract.contracthigh"
                            rv-hide="data.fundamental.week52high"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.contracthigh| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.contract.contracthigh | numeraljs '0,0.00'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-openinterest"
                            rv-if="data.contract.openinterest"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.openinterest| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.contract.openinterest | numeraljs '0,0'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-float"
                            rv-if="data.fundamental.avgvol30days"
                            rv-show="scope.floatadv"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.avpd30| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.fundamental.avgvol30days | numeraljs '0.00a'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-r">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-sharevolume"
                            rv-if="data.pricedata.sharevolume"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.volume| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.sharevolume | numeraljs '0,0'"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-changepercent"
                            rv-if="data.pricedata.changepercent"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.changepct| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-html="data.pricedata.changepercent | numeraljs '0.00' | postFix '%'"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-prevclose"
                            rv-if="data.pricedata.prevclose"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.prevclose| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.prevclose | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-low"
                            rv-if="data.pricedata.low"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.low| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.low | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-ask"
                            rv-if="data.pricedata.ask"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.ask| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.ask | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-asksize"
                            rv-if="data.pricedata.asksize"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.asksize| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.asksize | numeraljs '0'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-asksize"
                            rv-if="data.pricedata.vwap"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.vwap| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.vwap | numeraljs '0,0'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-week52low"
                            rv-if="data.fundamental.week52low"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.yearlow| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-popup-link"
                                        rv-on-click="data.togglePopup"
                                        data-popuptype="week52low"
                                    >
                                        {data.fundamental.week52low.content | asQHLast tLang}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-contractlow"
                            rv-if="data.contract.contractlow"
                            rv-hide="data.fundamental.week52low"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.contractlow| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.contract.contractlow | numeraljs '0,0.00'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-float"
                            rv-if="data.fundamental.float"
                            rv-show="scope.floatadv"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.float| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.fundamental.float | numeraljs '0.00a'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-exShName"
                            rv-if="data.key.exShName"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.exchange| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-tooltip"
                                        rv-title="data.key.exLgName"
                                        rv-on-mouseenter="data.qmtooltip"
                                        rv-text="data.key.exShName"
                                    >
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};
